export const arraysMatch = (a, b)=> {
    if (a?.length !== b?.length) return false; // Check if arrays have the same length
  
    // Sort both arrays and compare them
    a = a.slice().sort(); // `slice()` creates a shallow copy to avoid mutating the original array
    b = b.slice().sort();
  
    return a.every((value, index) => value === b[index]); // Check if all elements are equal
};

export const checkAnswer = (index, correctAnswer, answerSelectionType, answers, {
  userInput,
  currentQuestionIndex,
  incorrect,
  correct,
  setButtons,
  setIsCorrect,
  setIncorrectAnswer,
  setCorrect,
  setIncorrect,
  setShowNextQuestionButton,
  setUserInput,
  setUserAttempt,
}) => {
  const indexStr = `${index}`;
  const disabledAll = Object.keys(answers).map(() => ({ disabled: true }));
  const userInputCopy = [...userInput];
  if (answerSelectionType === 'single') {
      userInputCopy[currentQuestionIndex] = index;

    if (indexStr === correctAnswer) {
      if (correct.indexOf(currentQuestionIndex) < 0) {
        correct.push(currentQuestionIndex);
        incorrect = incorrect.filter(value => value !== currentQuestionIndex);
      }

      setButtons((prevState) => ({
        ...prevState,
        ...disabledAll,
        [index - 1]: {
            selected: true,
          className: (indexStr === correctAnswer) ? 'correct' : 'incorrect',
        },
      }));

      setIsCorrect(true);
      setIncorrectAnswer(false);
      setCorrect(correct);
      setIncorrect(incorrect);
      setShowNextQuestionButton(true);
    } else {
      if (incorrect.indexOf(currentQuestionIndex) < 0) {
        incorrect.push(currentQuestionIndex);
        correct = correct.filter(value => value !== currentQuestionIndex);
      }

        setButtons((prevState) => (
          {
            ...prevState,
            ...disabledAll,
            [index - 1]: {
                selected: true,
                className: (indexStr === correctAnswer) ? 'correct' : 'incorrect',
            },
          }
        ));

        setShowNextQuestionButton(true);

        setIncorrectAnswer(true);
        setIsCorrect(false);
        setIncorrect(incorrect);
        setCorrect(correct);
    }
  }
  else {

    if (userInputCopy[currentQuestionIndex] === undefined) {
      userInputCopy[currentQuestionIndex] = [];
    }
    if(userInputCopy[currentQuestionIndex]?.includes(index)) {
        
        userInputCopy[currentQuestionIndex] = userInputCopy[currentQuestionIndex].filter(value => value !== index);
        setButtons((prevState) => ({
            ...prevState,
            [index - 1]: {
              disabled: !prevState[index - 1],
              selected: false,
              className: (correctAnswer.includes(index)) ? 'correct' : 'incorrect',
            },
        }));
    }
    else{
        userInputCopy[currentQuestionIndex].push(index);
        setButtons((prevState) => ({
            ...prevState,
            [index - 1]: {
              disabled: !prevState[index - 1],
              selected: true,
              className: (correctAnswer.includes(index)) ? 'correct' : 'incorrect',
            },
        }));
    }

    if(arraysMatch(userInputCopy[currentQuestionIndex],correctAnswer)) {
        if (correct.indexOf(currentQuestionIndex) < 0) {
            correct.push(currentQuestionIndex);
            incorrect = incorrect.filter(value => value !== currentQuestionIndex);
        }
        setIsCorrect(true);
        setIncorrectAnswer(false);
        setCorrect(correct);
        setIncorrect(incorrect);
        setShowNextQuestionButton(true);
        setUserAttempt(1);
      }
      else{
        if (incorrect.indexOf(currentQuestionIndex) < 0) {
            incorrect.push(currentQuestionIndex);
            correct = correct.filter(value => value !== currentQuestionIndex);
        }

        setIncorrectAnswer(true);
        setIsCorrect(false);
        setIncorrect(incorrect);
        setCorrect(correct);
        setShowNextQuestionButton(true);
        setUserAttempt(1);
      }

    if(!userInputCopy[currentQuestionIndex]?.length) {
        setShowNextQuestionButton(false);
    }
  }
  setUserInput(userInputCopy);
};